import type {ResultsScope} from '../../../shared/ballotTypes';
import {Segmented, Toggle} from '../../../shared/sticker/stickers';

export type ResultsValue = {
    scope: ResultsScope;
    showCount: boolean;
    showShare: boolean;
    showVoters: boolean;
};

const SCOPES = [
    {value: 'winner' as const, label: 'Winner', hint: 'Drumroll, then the winner'},
    {value: 'top3' as const, label: 'Top 3', hint: '3rd, 2nd, winner'},
    {value: 'all' as const, label: 'All placements', hint: 'Last place up'},
];

export const ResultsSettings = ({
    value,
    disabled,
    onChange,
}: {
    value: ResultsValue;
    disabled: boolean;
    onChange: (next: ResultsValue) => void;
}) => (
    <>
        <div className="bt-label">Results: who to show</div>
        <Segmented
            name="results-scope"
            columns={3}
            options={SCOPES}
            value={value.scope}
            disabled={disabled}
            onChange={(scope) => onChange({...value, scope})}
        />
        <div className="bt-label">Results: what to show</div>
        <Toggle
            label="Vote count"
            hint="How many votes"
            checked={value.showCount}
            disabled={disabled}
            onChange={(showCount) => onChange({...value, showCount})}
        />
        <Toggle
            label="Vote share"
            hint="As a percentage"
            checked={value.showShare}
            disabled={disabled}
            onChange={(showShare) => onChange({...value, showShare})}
        />
        <Toggle
            label="Reveal votes"
            hint="Voter faces on each result"
            checked={value.showVoters}
            disabled={disabled}
            onChange={(showVoters) => onChange({...value, showVoters})}
        />
        {value.showVoters && (
            <div className="bt-warning bt-warning--wobble" role="status">
                ALL VOTES ARE PUBLICLY VISIBLE
                <small>Voters are told on their phone before they vote.</small>
            </div>
        )}
    </>
);
